import './TenantList.scss';
import Component from './TenantList.js';
export default Component;
